import React from "react";


const baseUrl=process.env.REACT_APP_BASE_URL;
const GoogleLogin = () => {
 
    const loginwithGoogle =()=>{
        window.open(`${baseUrl}/auth/google/callback`,"_self");
    }
    return (
        <div className="my-6">
            <button onClick={loginwithGoogle} className="flex md:w-full w-full mx-auto justify-center rounded-3xl bg-white p-2 text-black hover:bg-gray-200">
              <img
                src="https://freesvg.org/img/1534129544.png"
                className="mr-2 w-6 object-fill"
                alt="Google Icon"
              />
              Sign in with Google
            </button>
          </div>
    )
}

export default GoogleLogin;